import { useMemo } from "react";
import { useTranslation } from "react-i18next";

function ApproveStatusOptionMovement() {

    const { t } = useTranslation();
    const statusOptions = [
        { value: 'all', key: "all" },
        { value: 'Approved', key: "approve" },
        { value: 'Rejected', key: "reject" },
        { value: 'Draft', key: "draft" },
        { value: 'Pending', key: "pending" },
    ];
    const modifiedStatusMovement = useMemo(() => {
        const dropdown = statusOptions.map((opt) => ({
            ...opt,
            label: t(`approve-status.${opt.key}`),
            value: opt.value,
        }))
        return dropdown

    }, [statusOptions])



    return {
        modifiedStatusMovement
    }
}

export default ApproveStatusOptionMovement;
